import React from 'react';
import { styles } from './styles';
export function gridSubheaderPlugin(config) {
    return function () {
        return {
            subheaderAddons: [
                {
                    id: 'subheader',
                    render: function () {
                        return React.createElement('div', { className: styles.subheader }, config.content);
                    }
                }
            ]
        };
    };
}
//# sourceMappingURL=gridSubheaderPlugin.js.map